<xcm-assetgroup-detail [assetgroup]="assetgroup$ | async"></xcm-assetgroup-detail>